import '@fortawesome/fontawesome-svg-core/styles.css';

import { config } from '@fortawesome/fontawesome-svg-core';
import { createLogger, loggerStyles } from '@ricoh/ria.client.core/plugins/app/logger';
import { normalizeObject } from '@ricoh/ria.client.core/utils/data/object';

const logger = createLogger('fontawesome');

/** Inject Fontawesome. */
export function init() {
  config.autoAddCss = false;

  logger.writeWithData('info', `${loggerStyles.responseText('Init')} fontawesome`, normalizeObject(config));
}
